import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { PropertyType } from "Globals/Models/PropertyType";

export class PropertyTypeStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private propertyTypes: PropertyType[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.propertyTypes = initialState.propertyTypes;
    }

    @MobX.action
    public getPropertyTypeName(propertyTypeId: string | null): string {
        if (propertyTypeId == null) return "";
        if (propertyTypeId == "0") return "Error";
        if (propertyTypeId == "") return "Error";
        let value = this.getSortedByOrdinal.find((value) => propertyTypeId === value.id);
        return value ? value.name : "Unknown";
    }

    @MobX.computed
    public get getSortedByOrdinal(): PropertyType[] {
        return this.propertyTypes.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getPropertyTypeOptions(): KeyValuePair[] {
        return this.getSortedByOrdinal.map((value) => ({ value: value.id, key: value.name })) as KeyValuePair[];
    }
}
